import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/context/SettingsContext";
import { HeadManager } from "@/components/HeadManager";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Events from "@/pages/Events";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ink p-8 text-center text-slate-300">
          <p className="font-display text-2xl font-bold text-white">Something went wrong</p>
          <button className="rounded-full border border-cyan-400/40 px-6 py-2.5 text-sm text-cyan-300 hover:bg-cyan-400/10" onClick={() => window.location.reload()} data-testid="error-reload-button">
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function AppRouter() {
  const location = useLocation();

  // Detect OAuth session_id synchronously during render (before any /auth/me check)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  const isAdmin = location.pathname.startsWith("/admin");

  return (
    <SettingsProvider>
      <ScrollToTop />
      <HeadManager />
      <div className="grain relative">
        {!isAdmin && <Navbar />}
        <main className={!isAdmin ? "pt-16 lg:pt-20" : ""}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/events" element={<Events />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        {!isAdmin && <Footer />}
      </div>
      <Toaster position="bottom-right" theme="dark" />
    </SettingsProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AppRouter />
      </ErrorBoundary>
    </BrowserRouter>
  );
}
